import Vue from 'vue';
import Vuex from 'vuex';

import shared from '../shared/shared.store'
import projects from '../store/project.store'
import plan from '../store/plan.store'
import budget from '../store/budget.store'
import planExport from '../store/projectExport.store'


import menu from './modules/menu';
import layout from './modules/layout';
import {alert} from './modules/alert';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {},
	mutations: {
		changeLang(state, payload) {
			localStorage.setItem('currentLanguage', payload.id);
			localStorage.setItem('currentLanguageIcon', payload.icon);
			window.location.reload();
		}
	},
	actions: {
		setLang({commit}, payload) {
			commit('changeLang', payload);
		}
	},
	modules: {
		shared,
		projects,
		plan,
		budget,
		alert,
		layout,
		menu,
		planExport
	}
});

export default store

